import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { restoreIMSessionOnStartup } from '@/utils/im'
// TUIChatKit 改为 utils/tUIKitInit.ensureTUIKitReady() 延迟加载（见 im.js / MessageCenterDialog）
//按需加载elelement组件
import './ui/index'
Vue.config.productionTip = false
new Vue({
    router,
    store,
    async created() {
      // 刷新/直达：本地已有 token 与 userSig 时恢复 IM，与「登录弹窗内 loginIM」二选一不重复时由 loginIM 内部去重
      await restoreIMSessionOnStartup()
    },
    render: h => h(App)
}).$mount('#app')

